import kirtanAtIskcon1 from "../../../assets/images/kirtan-at-iskcon1.jpg";
import kirtanAtIskcon2 from "../../../assets/images/kirtan-at-iskcon2.jpg";
import kirtanAtIskcon3 from "../../../assets/images/kirtan-at-iskcon3.jpg";
import kirtanAtIskcon4 from "../../../assets/images/kirtan-at-iskcon4.jpg";
import kirtanAtIskcon5 from "../../../assets/images/kirtan-at-iskcon5.jpg";
import kirtanAtIskcon6 from "../../../assets/images/kirtan-at-iskcon6.jpg";
import kirtanAtIskcon7 from "../../../assets/images/kirtan-at-iskcon7.jpg";

export const kirtanAtIskconImages = [
  {
    id: 1,
    image: kirtanAtIskcon1,
  },
  {
    id: 2,
    image: kirtanAtIskcon2,
  },
  {
    id: 3,
    image: kirtanAtIskcon3,
  },
  {
    id: 4,
    image: kirtanAtIskcon4,
  },
  {
    id: 5,
    image: kirtanAtIskcon5,
  },
  {
    id: 6,
    image: kirtanAtIskcon6,
  },
  {
    id: 7,
    image: kirtanAtIskcon7,
  },
];

export const kirtanAtIskcon = [
  "ISKCON, kirtan involves singing and chanting the names of God in a call-and-response style, with the leader singing a line and the congregation responding in unison.",

  "The practice of kirtan is rooted in ancient Vedic tradition and has been passed down through generations of saints, sages, and devotees. It is said that the chanting of God’s names has the power to purify the heart and mind, awaken the soul, and bring one closer to the divine.",

  "In ISKCON, kirtan is often accompanied by traditional Indian instruments such as the mridanga, harmonium, and kartals, which add depth and richness to the music. The melodies are often simple and easy to follow, making it easy for even those with no prior musical experience to participate.",

  "During kirtan, participants focus their attention on the names and qualities of God, allowing themselves to be fully absorbed in the devotional mood of the music. As the chanting builds in intensity, the atmosphere becomes charged with spiritual energy, and it is not uncommon for participants to experience feelings of deep joy, peace, and connection to the divine.",

  "Kirtan is a powerful tool for spiritual transformation and is an essential part of the practice of bhakti yoga. Whether you are a seasoned practitioner or a newcomer to the path, the Practice of kirtan can help to awaken your heart and soul and bring you closer to the divine.",

  "The chanting and singing of the 16 syllable “ Hare Krishna Hare Krishna Krishna Krishna Hare Hare, Hare Rama Hare Rama Rama Rama Hare Hare! is the core of our movement as prescribed by Sri Chaitanya Mahaprabhu and as the followers of Sri Mahaprabhu, the ultimate goal is to preach the Mahamantra to each and every town of the world, which was fulfilled by the gracious efforts of Srila Prabhupada.",

  "We have the Narasimha’s Kirtan Mandali in our temple for this seva as well various devotees engaged in this service.",

  "Contact Details:",
];

export const contactDetails = [
  {
    id: 1,
    number: "+91 99984 07654",
  },
];
